/* nb-article-product-links.js
   Auto-links the FIRST occurrence of key product mentions inside the article body.
   - Skips text inside <a>, <h1-h6>, <code>, <pre>, <figure> elements
   - Skips a term if any link to that product URL already exists on the page
   - Longest terms matched first (so "nuviebaby Clean™" wins over "Clean")
   - Whole-word match only
*/
(function () {
  'use strict';

  var PRODUCTS = [
    {
      url: '/products/nuviebaby-clean',
      terms: ['nuviebaby Clean™', 'nuviebaby Clean', 'the Clean machine']
    },
    {
      url: '/products/clean365bundle',
      terms: ['Clean 365™ bundle', 'Clean 365 bundle', 'Clean 365™', 'Clean 365']
    },
    {
      url: '/products/clean730bundle',
      terms: ['Clean 730™ bundle', 'Clean 730 bundle', 'Clean 730™', 'Clean 730']
    },
    {
      url: '/products/super-clean-washing-tablets',
      terms: ['Super Clean™ tablets', 'Super Clean tablets', 'Super Clean™ washing tablets', 'Super Clean washing tablets', 'Super Clean™', 'Super Clean']
    },
    {
      url: '/products/hepa-13-replacement-filters-2-pack',
      terms: ['HEPA-13 replacement filter', 'HEPA-13 filter', 'HEPA filter', 'HEPA-13']
    },
    {
      url: '/products/1-5m-extended-drain-hose',
      terms: ['1.5m extended drain hose', 'extended drain hose', 'drain hose']
    }
  ];

  var SKIP_ANCESTORS = /^(A|H1|H2|H3|H4|H5|H6|CODE|PRE|FIGURE|FIGCAPTION)$/;

  function init() {
    var body = document.querySelector('.nb-art__body[data-nb-article-body]');
    if (!body) return;

    PRODUCTS.forEach(function (product) {
      // Skip product entirely if any existing link already points to it
      var existing = body.querySelector('a[href*="' + product.url + '"]');
      if (existing) {
        product.linked = true;
      }
    });

    // Sort all candidate terms longest first, retaining their product
    var pairs = [];
    PRODUCTS.forEach(function (product) {
      if (product.linked) return;
      product.terms.forEach(function (term) {
        pairs.push({ product: product, term: term });
      });
    });
    pairs.sort(function (a, b) {
      return b.term.length - a.term.length;
    });

    function escapeRegex(s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    pairs.forEach(function (pair) {
      if (pair.product.linked) return;

      // Whole-word boundary; case-sensitive (product names are titlecased)
      var pattern = new RegExp(
        '(^|[\\s,;:.!?()\\u2014\\u2013\\u00a0])(' + escapeRegex(pair.term) + ')(?=[\\s,;:.!?()\\u2014\\u2013\\u00a0]|$)',
        ''
      );

      var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || node.nodeValue.indexOf(pair.term) === -1) {
            return NodeFilter.FILTER_REJECT;
          }
          var ancestor = node.parentNode;
          while (ancestor && ancestor !== body) {
            if (SKIP_ANCESTORS.test(ancestor.nodeName)) {
              return NodeFilter.FILTER_REJECT;
            }
            ancestor = ancestor.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var node = walker.nextNode();
      while (node) {
        var match = pattern.exec(node.nodeValue);
        if (match) {
          var before = node.nodeValue.slice(0, match.index + match[1].length);
          var matched = match[2];
          var after = node.nodeValue.slice(match.index + match[1].length + matched.length);

          var beforeNode = document.createTextNode(before);
          var link = document.createElement('a');
          link.href = pair.product.url;
          link.className = 'nb-art__product-link';
          link.dataset.nbAutolink = 'true';
          link.textContent = matched;
          var afterNode = document.createTextNode(after);

          var parent = node.parentNode;
          parent.insertBefore(beforeNode, node);
          parent.insertBefore(link, node);
          parent.insertBefore(afterNode, node);
          parent.removeChild(node);

          pair.product.linked = true;
          return; // first occurrence only — done with this product
        }
        node = walker.nextNode();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
